<template>
    <div>
        <div v-if="value !== null" class="dinlineb">
            <span :class="['avatar mr-1 pt-2', classNames]">
                <icon :icon="icon" style="line-height: initial;"></icon>
            </span>
            <span class="avatar-name">{{ $filters.capitalize(value) }}</span>
        </div>
        <span v-else>
            {{ placeholder }}
        </span>
    </div>
</template>
<script>

    import Icon from 'vcomponents/utilities/Icon.vue'
    export default {
        props : {
            icon: {
                // css icon class
                type: String,
                default: null
            },
            bkgColor: {
                type : String,
                validator: function (value) {
                    return ['purple', 'yellow', 'red', 'blue', 'grey', 'green' ]
                        .indexOf(value) !== -1
                }
            },
            value: {
                // unix timestamp
                type: String,
                default: null,
            },
            placeholder: {
                default: '',
                required: false
            },
        },
        data() {
            return {
                map: [
                    { name: 'purple', class: 'color30-bkg', text: 'white' },
                    { name: 'yellow', class: 'orange-bkg', text: 'white' },
                    { name: 'red', class: 'red-bkg', text: 'white' },
                    { name: 'blue', class: 'color14-bkg', text: 'white' },
                    { name: 'grey', class: 'gray-80-bkg', text: 'white' },
                    { name: 'green', class: 'color20-bkg', text: 'white' },
                ]
            }
        },
        computed: {
            classNames() {
                return this.classObject(this.bkgColor).class + " " + this.classObject(this.bkgColor).text
            },
        },
        methods: {
            classObject(name) {
                return this.map.find((classObject) => classObject.name == this.bkgColor);
            }
        },
        components: {
            Icon
        }
    }
</script>

<style scoped lang="scss">
@import '~@sellsy/styleguide/src/_variables';
.avatar-name {
    transition  : all 0.3s linear;
    vertical-align: middle;
    max-width: 150px;
    &:not(.avatar-name-disabled):hover{
        color: $primary-50;
    }
}
</style>